import { CellWrapper, useCellContext } from "@silevis/reactgrid";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import { useRef, useState } from "react";
import dayjs from "../../dayjs";
import { parsePastedDate } from "./parsePastedDate";

const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";

interface Props {
  readonly value: Dayjs | undefined;
  readonly style?: Record<string, string | number>;
  readonly onValueChanged: (data: Dayjs | undefined) => void;
}

const DateCell: FC<Props> = ({ value, style, onValueChanged }) => {
  const { isFocused } = useCellContext();
  const targetInputRef = useRef<HTMLInputElement>(null);
  const [isEditMode, setEditMode] = useState(false);
  const formattedDate = value?.format(DISPLAY_DATE_FORMAT) ?? "";
  return (
    <CellWrapper
      onStringValueRequested={() => value?.format(DISPLAY_DATE_FORMAT) ?? ""}
      onStringValueReceived={(v) => {
        const parsed = parsePastedDate(v);
        if (v.trim() === "" || parsed) {
          onValueChanged(parsed);
        }
      }}
      style={{ padding: ".2rem", textAlign: "center", outline: "none", ...style }}
      onDoubleClick={() => {
        if (isFocused) {
          setEditMode(true);
        }
      }}
      onKeyDown={(e) => {
        if (!isEditMode && e.key === "Enter") {
          e.stopPropagation();
          setEditMode(true);
        }
      }}
    >
      {" "}
      {isEditMode ? (
        <input
          className="rg-input"
          type="date"
          defaultValue={value?.format("YYYY-MM-DD")}
          onBlur={(e) => {
            if (e.currentTarget.value) {
              onValueChanged(dayjs.utc(e.currentTarget.value));
            }
            setEditMode(false);
          }}
          onPointerDown={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setEditMode(false);
            } else if (e.key === "Enter") {
              onValueChanged(dayjs.utc(e.currentTarget.value));
              setEditMode(false);
            }
          }}
          autoFocus
          ref={targetInputRef}
        />
      ) : (
        formattedDate
      )}{" "}
    </CellWrapper>
  );
};

export default DateCell;
